import { memo, useMemo, useState } from 'react';

import AngularGradient from './AngularGradient';
import BackgroundImage from './BackgroundImage';
import {
  FILL_TYPE_ANGULAR_GRADIENT,
  FILL_TYPE_IMAGE,
  FILL_TYPE_LINEAR_GRADIENT,
  FILL_TYPE_RADIAL_GRADIENT,
} from './constants';
import LinearGradient from './LinearGradient';
import RadialGradient from './RadialGradient';
import { Fill } from './types';

type SvgFillLibraryProps = {
  fills: {
    [key: string]: Fill;
  };
  noSvgWrapper?: boolean;
};

const SvgFillLibrary = ({ fills, noSvgWrapper }: SvgFillLibraryProps) => {
  // @TODO: Start disabled and provide a way to enable canvas rendering whene it's convenient?
  const [canvasEnabled] = useState(false);

  const renderedFills = useMemo(
    () => (
      <>
        {(Object.entries(fills) as [string, Fill][]).map(([key, fill]) => {
          switch (fill.type) {
            case FILL_TYPE_LINEAR_GRADIENT:
              return <LinearGradient key={key} id={fill.id} {...fill.props} />;
            case FILL_TYPE_RADIAL_GRADIENT:
              return <RadialGradient key={key} id={fill.id} {...fill.props} />;
            case FILL_TYPE_ANGULAR_GRADIENT:
              return (
                <AngularGradient
                  key={key}
                  id={fill.id}
                  canvasEnabled={canvasEnabled}
                  {...fill.props}
                />
              );
            case FILL_TYPE_IMAGE:
              return <BackgroundImage key={key} id={fill.id} {...fill.props} />;
            default:
              return null;
          }
        })}
      </>
    ),
    [fills, canvasEnabled]
  );

  if (noSvgWrapper) {
    return renderedFills;
  }

  return (
    <svg
      style={{
        bottom: 0,
        height: 1,
        opacity: 0,
        pointerEvents: 'none',
        position: 'fixed',
        right: 0,
        width: 1,
        zIndex: -1,
      }}
      role="presentation"
      aria-hidden
    >
      {renderedFills}
    </svg>
  );
};

SvgFillLibrary.defaultProps = {
  fills: {},
  noSvgWrapper: false,
};

export default memo(SvgFillLibrary);
